import PageHeader from 'src/core/ui/PageHeader';
import Footer from 'src/core/ui/helpers/Footer';
import ContentCardsContainer, { CardType, ContentCard } from 'src/core/ui/ContentCard';
import { CustomDataGrid } from 'src/core/tables/CustomDataGrid';
import { generateTablePageButtons } from 'src/core/tables/generateTablePageButtons';
import { useSalesShippingMethodsTable } from 'src/pages/settings/admin/salesShippingMethods/useShippingMethodsTable';

export const SalesShippingMethodsTablePage = () => {
    const [columns, tableSettings] = useSalesShippingMethodsTable();
    return (
        <>
            <PageHeader {...{
                title: "Sales Shipping Methods", subTitle: "View sales shipping methods and external shipping codes",
                components: generateTablePageButtons(tableSettings),
            }} />
            <ContentCardsContainer>
                <ContentCard cardId="Sales Shipping Methods" cardTypes={[CardType.noHeader]} contentPadding={0}>
                    <CustomDataGrid columns={columns} tableSettings={tableSettings} />
                </ContentCard>
            </ContentCardsContainer>
            <Footer />
        </>
    );
};

export default SalesShippingMethodsTablePage;
